import { useEffect, useState, useCallback } from 'react'

export const useSelectCridNotification = () => {
  const [show, setShow] = useState(true)

  useEffect(() => {
    const shouldShow = localStorage.getItem('showSelectCridNotification') !== 'false'
    setShow(shouldShow)
  }, [])

  const dismissNotification = useCallback(() => {
    localStorage.setItem('showSelectCridNotification', 'false')
    setShow(false)
  }, [])

  return [show, dismissNotification]
}
